/* import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbAuthService, NbLoginComponent, NB_AUTH_OPTIONS } from '@nebular/auth';
import { take } from 'rxjs/operators';
import { NotifierService } from '../../../_services/notifier.service';
import { NbThemeService } from '@nebular/theme';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends NbLoginComponent {

  constructor(
    // Servizi richiesti da NbLoginComponent
    protected authService: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected override options = {},
    protected override cd: ChangeDetectorRef,
    protected override router: Router,
    private theme: NbThemeService,
    // Servizi custom
    private alertService: NotifierService,
    private activatedRoute: ActivatedRoute,
  ){
    super(
      authService,
      options,
      cd,
      router,
    );
  }

  ngOnInit(): void {
    localStorage.removeItem('foo');
    this.theme.changeTheme('black');
    // Parametri utilizzati per mostrare una notifica quando si atterra alla pagina dopo aver cliccato un link di validazione per mail
    this.activatedRoute.queryParams.pipe(take(1)).subscribe(params => {
      let status = params['status'];
      let message = params['message'];
      if ( status && message ) {
        if ( status == "success" ){
          this.alertService.success("SUCCESSO", message);
        }
        if ( status == "error" )
          this.alertService.success("ERRORE", message);
      }
    });
  }

}

 */
































import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbAuthService, NbLoginComponent, NB_AUTH_OPTIONS } from '@nebular/auth';
import { take } from 'rxjs/operators';
import { NotifierService } from '../../../_services/notifier.service';
import { NbThemeService } from '@nebular/theme';
import { RoleProvider } from '../../../_helpers/role.provider';

@Component({
    selector: 'login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent extends NbLoginComponent {

  showPassword = false;

  constructor(
    protected authService: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected override options: any,
    protected override cd: ChangeDetectorRef,
    protected override router: Router,
    private theme: NbThemeService,
    private alertService: NotifierService,
    private activatedRoute: ActivatedRoute,
    private roleProvider: RoleProvider,
  ) {
    super(authService, options, cd, router);
  }

  ngOnInit(): void {
    localStorage.removeItem('foo');
    this.theme.changeTheme('black');

    this.activatedRoute.queryParams.pipe(take(1)).subscribe(params => {
      const status = params['status'];
      const message = params['message'];

      if (status && message) {
        if (status === 'success') this.alertService.success('SUCCESSO', message);
        if (status === 'error') this.alertService.success('ERRORE', message);
      }
    });
  }

  // 🔥 THIS is the important part
  // overrides Nebular default redirect behavior
  override login(): void {
    // Enter key / double click must not send a second login while one is pending (5 attempts / 15 min).
    if (this.submitted) return;

    this.errors = [];
    this.messages = [];
    this.submitted = true;

    this.authService.authenticate(this.strategy, this.user)
      .pipe(take(1))
      .subscribe((result: any) => {

        this.submitted = false;

        if (result.isSuccess()) {

          const role = this.roleProvider.getUserRole()

          switch (role) {
            case 'ev_manager':
              this.router.navigate(['/pages/ev_dashboard']);
              break;
            case 'installer':
              this.router.navigate(['/pages/crm']);
              break;

            default:
              this.router.navigate(['/pages/home']);
          }

        } else {
          this.errors = result.getErrors();
        }

        this.cd.detectChanges();
      });
  }
}
